import lazyWithRetry from '../../../../lazy-retry';

import * as ELEMENT_TYPES from '../../../redux/constants';

const renderer = (load) =>
  lazyWithRetry(() => load().then((module) => ({ default: module.default.element })));

export default {
  [ELEMENT_TYPES.ELEMENT_TYPE__CANVAS]: renderer(() =>
    import('../element/canvas-element/canvas-element'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__DESCRIPTION]: renderer(() =>
    import('../element/description-element/description-element'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__DISPLAY_REWARD]: renderer(() =>
    import('../element/display-reward-element/display-reward-element'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__HEADER]: renderer(() =>
    import('../element/header-element/header-element'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__HYPERLINK]: renderer(() =>
    import('../element/hyperlink-element/hyperlink-element'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__IMAGE]: renderer(() =>
    import('../element/image-element/image-element'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__TEXT]: renderer(() =>
    import('../element/text-element/text-element'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__BOOLEAN_INPUT]: renderer(() =>
    import('../element/boolean-input/boolean-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__CHECKBOX_INPUT]: renderer(() =>
    import('../element/checkbox-input/checkbox-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__DATE_INPUT]: renderer(() =>
    import('../element/date-input/date-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__EMAIL_INPUT]: renderer(() =>
    import('../element/email-input/email-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__EMAIL_VERIFICATION_INPUT]: renderer(() =>
    import('../element/email-verification-input/email-verification-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__IMAGE_INPUT]: renderer(() =>
    import('../element/image-input/image-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__IMAGE_UPLOAD_INPUT]: renderer(() =>
    import('../element/image-upload-input/image-upload-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__IMAGE_MULTI_SELECT_INPUT]: renderer(() =>
    import('../element/image-multi-select-input/image-multi-select-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__GIFTBIT_REWARD_INPUT]: renderer(() =>
    import('../element/giftbit-reward-input/giftbit-reward-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__MEDIA_INPUT]: renderer(() =>
    import('../element/media-input/media-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__NUMBER_INPUT]: renderer(() =>
    import('../element/number-input/number-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__PHONE_NUMBER_INPUT]: renderer(() =>
    import('../element/phone-number-input/phone-number-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__RADIO_INPUT]: renderer(() =>
    import('../element/radio-input/radio-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__RANKING_IMAGE_INPUT]: renderer(() =>
    import('../element/ranking-image-input/ranking-image-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__RANKING_INPUT]: renderer(() =>
    import('../element/ranking-input/ranking-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__SLIDE_INPUT]: renderer(() =>
    import('../element/slide-input/slide-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__SOCIAL_INPUT]: renderer(() =>
    import('../element/social-input/social-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__TAROT_INPUT]: renderer(() =>
    import('../element/tarot-input/tarot-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__TEXT_INPUT]: renderer(() =>
    import('../element/text-input/text-input'),
  ),
  [ELEMENT_TYPES.ELEMENT_TYPE__TEXTAREA]: renderer(() => import('../element/textarea/textarea')),
  [ELEMENT_TYPES.ELEMENT_TYPE__ZIP_INPUT]: renderer(() => import('../element/zip-input/zip-input')),
};
